import React from 'react'

import SectionHeader from 'components_new/molecules/SectionHeader'
import {
  TreeColumn,
  TreeNode
} from 'components_new/molecules/TreeDndTable/types'

import { useTranslation } from 'language/translator'
import { TKeyMetric, UpdateKeyMetricOrderItem } from 'types/GlobalKeyMetric'
import { useIsMobile } from 'utils/hooks'

export const useColumns = (params: {
  editMode: boolean
  preview?: boolean
}): TreeColumn[] => {
  const { editMode, preview } = params

  const isMobile = useIsMobile()
  const { t } = useTranslation()

  if (isMobile)
    return [
      {
        align: 'left',
        key: 'name',
        width: '100%'
      },
      {
        align: 'left',
        key: 'content',
        width: '0px'
      }
    ]

  return [
    {
      align: 'left',
      key: 'name',
      padding: preview ? 'none' : undefined,
      title: preview ? (
        <SectionHeader
          color="secondary"
          icon={{ color: 'disabled', name: 'KeyMetrics' }}
          size="small"
          title={t('key_metrics', 'key_metrics')}
        />
      ) : (
        t('key_metrics', 'key_metric')
      ),
      width: '40%'
    },
    {
      align: 'right',
      key: 'current',
      title: t('global', 'now'),
      width: '7.5%'
    },
    {
      align: 'right',
      key: 'target',
      title: t('key_metrics', 'target'),
      width: '7.5%'
    },
    {
      align: 'left',
      key: 'unit',
      title: '', // unit
      width: '2.5%'
    },
    {
      align: 'right',
      key: 'twelveMonth',
      title: '12m', // $TODO: later.
      width: '7.5%'
    },
    {
      align: 'right',
      key: '1m',
      title: '1m', // $TODO: later.
      width: '7.5%'
    },
    {
      align: 'right',
      key: 'trend',
      title: preview ? undefined : t('global', 'trend'),
      width: '10%'
    },
    {
      align: 'left',
      key: 'resources',
      title: ' ',
      width: '2.5%'
    },
    {
      align: 'left',
      key: 'groups',
      title: ' ',
      width: '2.5%'
    },
    {
      align: 'left',
      key: 'owner',
      title: ' ',
      width: '2.5%'
    },
    ...(editMode
      ? [
          {
            align: 'right' as const,
            title: ' ',
            key: 'actions',
            width: '5%'
          }
        ]
      : [])
  ]
}

export const formatOrderItem = (
  item: TreeNode,
  index: number
): UpdateKeyMetricOrderItem => {
  return {
    id: item.id,
    index,
    children: item.children
      ? item.children.map((c, i) => formatOrderItem(c, i))
      : undefined
  } as UpdateKeyMetricOrderItem
}

export const toTreeNodes = (items: TKeyMetric[]): TreeNode[] =>
  items.map((km) => ({
    children: km.children.length > 0 ? toTreeNodes(km.children) : undefined,
    id: km.id
  }))
